
/* styles */
require("!!vue-style-loader!css-loader!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-d4b7bbe4&scoped=true!sass-loader!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PCHeader.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PCHeader.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-d4b7bbe4!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PCHeader.vue"),
  /* scopeId */
  "data-v-d4b7bbe4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/global/partials/LoggedInHeader/PCHeader.vue
// module id = 594
// module chunks = 0